module.exports = __webpack_public_path__ + "img/rightarrow.787ad9b1.svg";